define('services/teamService',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',

    'models/Team',

    'services/apiCore'
], function(
    _,
    Promise,
    ko,

    Team,

    apiCore

    ){
    "use strict";

    var PATH_DELIMITER = '{0}',
        PATH_TEAMS = '/teams',
        PATH_TEAM  = PATH_TEAMS + '/' + PATH_DELIMITER,
        PATH_TEAMS_SEARCH = PATH_TEAMS + '/search';

        return {

            /**
             * Gets a list of teams.
             * @param options - The params to include - structured like {
             *     pageNumber : 1,
             *     pageSize   : 25,
             *     name       : '*'
             * }
             * @returns {*} - array of "models/Team" objects
             */
            getTeams: function( options ) {
                var params = _.assign( {
                    pageNumber : 1,
                    pageSize   : 25
                }, options );
                return apiCore.v2.get( PATH_TEAMS ,params )
                    .then( function( response ){
                        response.entities =  _.map(response.entities, function( teamData ){
                           return new Team( teamData );
                       });
                        return response;
                    });
            },

            /**
             *  Gets a team based on the team's guid
             * @param teamId - the guid of the team
             * @returns {*}
             */
            getTeam : function( teamId ) {
                return apiCore.v2.get( PATH_TEAM.replace( PATH_DELIMITER, teamId ) )
                    .then( function( teamData ){
                        return new Team( teamData );
                    });
            },


            /**
             * Searches for teams that meet the criteria of the query
             *
             * @param {object} query
             *
             * @returns {*} - array of "models/Team" objects
             */
            searchTeams: function (query) {
                return apiCore.v2.post(PATH_TEAMS_SEARCH, query)
                    .then(function (response) {
                        return _.map(response.results, function( teamData ){
                           return new Team( teamData );
                       });
                    });
            }
        };
});

